import React from "react";

//pages
import Groups from "../views/dashboard/app/groups";
import GroupDetail from "../views/dashboard/app/group-detail";
import FriendList from "../views/dashboard/app/friend-list";
import ProfileImages from "../views/dashboard/app/profile-images";
import ProfileVideos from "../views/dashboard/app/profile-videos";
import ProfileEvents from "../views/dashboard/app/profile-events";
import EventDetail from "../views/dashboard/app/event-detail";
import Calendar from "../views/dashboard/app/calendar";
import Birthday from "../views/dashboard/app/birthday";
import Weather from "../views/dashboard/app/weather";
import Music from "../views/dashboard/app/music";
import CatergoryGrid from "../views/dashboard/store/store-category-grid";
import CatergoryList from "../views/dashboard/store/store-category-list";
import StoreDetail from "../views/dashboard/store/store-detail";
import StoreCheckout from "../views/dashboard/store/store-checkout";

//market and profile pages
import Market1 from "../views/dashboard/market-place/market1";
import Market2 from "../views/dashboard/market-place/market2";
import Profile1 from "../views/dashboard/profiles/profile1";
import Profile2 from "../views/dashboard/profiles/profile2";
import Profile3 from "../views/dashboard/profiles/profile3";
import ProductDetail from "../views/dashboard/store/product-detail";
import UpcomingCourses from "../views/dashboard/store/LessonPlans";
import StoreDetailOLD from "../views/dashboard/store/store-old";
import ProtectedRoute from "./ProtectedRoute";
import LessonPlans from "../views/dashboard/store/LessonPlans";
import PGT_lesson from "../views/dashboard/store/PGT_lesson";
import TGT_lesson from "../views/dashboard/store/TGT_lesson";
import Feedback from "../views/dashboard/store/Pre_Feedback";
import Pre_Feedback from "../views/dashboard/store/Pre_Feedback";
import Post_Feedback from "../views/dashboard/store/Post_Feedback";
import ViewAllTraining from "../views/dashboard/store/online-training/ViewAllTraining";
import VideoViewer from "../views/dashboard/store/online-training/VideoViewer";
import LMSOrientation from "../views/dashboard/store/LmsOritent";
import Programme_Journey from "../views/dashboard/store/Programme_Journey";
import AssginMent from "../views/dashboard/store/AssginMent";
import PreTrainingFeedback from "../views/dashboard/blog/Pre-Training-Feedback";
import ProgrammeDocuments from "../views/dashboard/store/ProgrammeDocuments";
import AssignmentsSection from "../views/dashboard/app/AssginMentDarwer";
import FoodFeedbackForm from "../views/dashboard/blog/FoodFeedback/FoodFeedbackForm";
import DownloadCertificate from "../views/dashboard/store/DownloadCertificate";
import Top from "../views/dashboard/app/Top/Top";
import FeedBack from "../views/dashboard/app/FeedBack/FeedBack";

// protect routes
export const Layout1Router = [
  {
    path: "/discussion",
    element: <ProtectedRoute element={<Groups />} />,
  },
  {
    path: "dashboards/app/group-detail/:id",
    element: <ProtectedRoute element={<GroupDetail />} />,
  },
  {
    path: "dashboards/app/friend-list",
    element: <ProtectedRoute element={<FriendList />} />,
  },
  {
    path: "dashboards/app/profile-images",
    element: <ProtectedRoute element={<ProfileImages />} />,
  },
  {
    path: "dashboards/app/profile-videos",
    element: <ProtectedRoute element={<ProfileVideos />} />,
  },
  {
    path: "dashboards/app/profile-events",
    element: <ProtectedRoute element={<ProfileEvents />} />,
  },
  {
    path: "dashboards/app/event-detail",
    element: <ProtectedRoute element={<EventDetail />} />,
  },
  {
    path: "dashboards/app/calendar",
    element: <ProtectedRoute element={<Calendar />} />,
  },
  {
    path: "dashboards/app/birthday",
    element: <ProtectedRoute element={<Birthday />} />,
  },
  {
    path: "dashboards/app/weather",
    element: <ProtectedRoute element={<Weather />} />,
  },
  {
    path: "dashboards/app/music",
    element: <ProtectedRoute element={<Music />} />,
  },
  {
    path: "/FoodFeedbackForm",
    element: <ProtectedRoute element={<FoodFeedbackForm />} />,
  },
  {
    path: "/DownloadCertificate",
    element: <ProtectedRoute element={<DownloadCertificate />} />,
  },
  {
    path: "dashboards/store/store-category-grid",
    element: <ProtectedRoute element={<CatergoryGrid />} />,
  },
  {
    path: "dashboards/store/store-category-list",
    element: <ProtectedRoute element={<CatergoryList />} />,
  },
  {
    path: "/upcoming-courses",
    element: <ProtectedRoute element={<UpcomingCourses />} />,
  },
  {
    path: "/lesson-plan",
    element: <ProtectedRoute element={<LessonPlans />} />,
  },
  {
    path: "/online-training",
    element: <ProtectedRoute element={<ViewAllTraining />} />,
  },
  {
    path: "/certificate",
    element: <ProtectedRoute element={<StoreDetailOLD />} />,
  },
  {
    path: "/enrolled-courses",
    element: <ProtectedRoute element={<StoreDetail />} />,
  },
  {
    path: "/programme-Journey",
    element: <ProtectedRoute element={<Programme_Journey />} />,
  },
  {
    path: "/assginMent",
    element: <ProtectedRoute element={<AssginMent />} />,
  },
  {
    path: "/top",
    element: <ProtectedRoute element={<Top />} />,
  },
  {
    path: "/feedback",
    element: <ProtectedRoute element={<FeedBack />} />,
  },
  {
    path: "/assignments",
    element: <ProtectedRoute element={<AssignmentsSection />} />,
  },
  {
    path: "/preTraningFeedback",
    element: <ProtectedRoute element={<PreTrainingFeedback />} />,
  },
  {
    path: "/ProgrammeDocuments",
    element: <ProtectedRoute element={<ProgrammeDocuments />} />,
  },
  {
    path: "/pre-feedback/:school_code",
    element: <ProtectedRoute element={<Pre_Feedback />} />,
  },
  {
    path: "/post-feedback/:school_code",
    element: <ProtectedRoute element={<Post_Feedback />} />,
  },
  {
    path: "dashboards/store/store-checkout",
    element: <ProtectedRoute element={<StoreCheckout />} />,
  },
  {
    path: "/lesson-plan/:school_code",
    element: <ProtectedRoute element={<PGT_lesson />} />,
  },
  {
    path: "/lesson-plan/TGT",
    element: <ProtectedRoute element={<TGT_lesson />} />,
  },
  {
    path: "/lesson-plan/LMSOrientation",
    element: <ProtectedRoute element={<LMSOrientation />} />,
  },

  //---------------- Course Videos ----------------
  {
    path: "/training-videos",
    element: <ProtectedRoute element={<VideoViewer />} />,
  },

  // {
  //   path: "dashboards/store/product-detail",
  //   element: <ProtectedRoute element={<ProductDetail />} />,
  // },
  {
    path: "dashboards/market-place/market1",
    element: <ProtectedRoute element={<Market1 />} />,
  },
  {
    path: "dashboards/market-place/market2",
    element: <ProtectedRoute element={<Market2 />} />,
  },
  {
    path: "dashboards/profiles/profile1",
    element: <ProtectedRoute element={<Profile1 />} />,
  },
  {
    path: "dashboards/profiles/profile2",
    element: <ProtectedRoute element={<Profile2 />} />,
  },
  {
    path: "dashboards/profiles/profile3",
    element: <ProtectedRoute element={<Profile3 />} />,
  },
];